import { render, staticRenderFns } from "./CreatDsGroup.vue?vue&type=template&id=5b652252&"
import script from "./CreatDsGroup.vue?vue&type=script&lang=js&"
export * from "./CreatDsGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreatDsGroup.vue?vue&type=style&index=0&id=5b652252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports